import React from "react";
import Button from "@mui/material/Button";

import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import { ClickActionEvent } from "../../util/analytics";

import thoughtList from "./Data";

import OneThought from "./OneThought";

const sxHeroContent = { py: 8 };
const sxCardGrid = { pt: 0, pb: 4, textAlign: "center" };

export default function MyThoughts() {
  const [selectedItem, setSelectedItem] = React.useState(0);

  const PreviousQuote = (t) => {
    if (selectedItem === 0) setSelectedItem(thoughtList.length - 1);
    else setSelectedItem(selectedItem - 1);
    ClickActionEvent(
      "MyThoughts " + thoughtList[selectedItem].desc,
      "my thoughts quotes section",
      "my thoughts  previous quote clicked"
    );
  };

  const NextQuote = (event) => {
    if (selectedItem === thoughtList.length - 1) setSelectedItem(0);
    else setSelectedItem(selectedItem + 1);
    ClickActionEvent(
      "MyThoughts " + thoughtList[selectedItem].desc,
      "my thoughts quotes section",
      "my thoughts  next quote clicked"
    );
  };

  return (
    <React.Fragment>
      <div style={{ backgroundColor: "#37BEB0" }}>
        <Box sx={{ ...sxHeroContent, backgroundColor: "#37BEB0" }}>
          <Container maxWidth="lx">
            <Typography
              component="h1"
              variant="h3"
              align="center"
              sx={{ color: "#0c6170" }}
              gutterBottom
            >
              My Thoughts 🤔
            </Typography>
          </Container>
        </Box>
        <Container align="center" sx={sxCardGrid} maxWidth="lx">
          <OneThought item={thoughtList[selectedItem]} />
          <Button
            style={{
              backgroundColor: "#0c6170",
              margin: "10px",
              color: "#dbf5f0",
            }}
            size="small"
            color="primary"
            onClick={() => PreviousQuote()}
          >
            Previous
          </Button>
          <Button
            style={{
              backgroundColor: "#0c6170",
              margin: "10px",
              color: "#dbf5f0",
            }}
            size="small"
            color="primary"
            onClick={() => NextQuote()}
          >
            Next
          </Button>
        </Container>
      </div>
    </React.Fragment>
  );
}
